export const COUNTRY_OPTIONS: Array<{ label: string; code: string }> = [
  // North America
  { label: 'US/Canada (+1)', code: '+1' },
  { label: 'Mexico (+52)', code: '+52' },
  // South America
  { label: 'Brazil (+55)', code: '+55' },
  { label: 'Argentina (+54)', code: '+54' },
  { label: 'Chile (+56)', code: '+56' },
  { label: 'Colombia (+57)', code: '+57' },
  { label: 'Peru (+51)', code: '+51' },
  // Europe
  { label: 'UK (+44)', code: '+44' },
  { label: 'Ireland (+353)', code: '+353' },
  { label: 'Germany (+49)', code: '+49' },
  { label: 'France (+33)', code: '+33' },
  { label: 'Spain (+34)', code: '+34' },
  { label: 'Italy (+39)', code: '+39' },
  { label: 'Netherlands (+31)', code: '+31' },
  { label: 'Belgium (+32)', code: '+32' },
  { label: 'Switzerland (+41)', code: '+41' },
  { label: 'Austria (+43)', code: '+43' },
  { label: 'Sweden (+46)', code: '+46' },
  { label: 'Norway (+47)', code: '+47' },
  { label: 'Denmark (+45)', code: '+45' },
  { label: 'Finland (+358)', code: '+358' },
  { label: 'Poland (+48)', code: '+48' },
  { label: 'Portugal (+351)', code: '+351' },
  { label: 'Greece (+30)', code: '+30' },
  { label: 'Czechia (+420)', code: '+420' },
  { label: 'Hungary (+36)', code: '+36' },
  // APAC
  { label: 'Australia (+61)', code: '+61' },
  { label: 'New Zealand (+64)', code: '+64' },
  { label: 'Japan (+81)', code: '+81' },
  { label: 'South Korea (+82)', code: '+82' },
  { label: 'China (+86)', code: '+86' },
  { label: 'Hong Kong (+852)', code: '+852' },
  { label: 'Singapore (+65)', code: '+65' },
  { label: 'Malaysia (+60)', code: '+60' },
  { label: 'Indonesia (+62)', code: '+62' },
  { label: 'Thailand (+66)', code: '+66' },
  { label: 'Philippines (+63)', code: '+63' },
  { label: 'Vietnam (+84)', code: '+84' },
  { label: 'India (+91)', code: '+91' },
  { label: 'Pakistan (+92)', code: '+92' },
  { label: 'Bangladesh (+880)', code: '+880' },
  // Middle East
  { label: 'UAE (+971)', code: '+971' },
  { label: 'Saudi Arabia (+966)', code: '+966' },
  { label: 'Qatar (+974)', code: '+974' },
  { label: 'Kuwait (+965)', code: '+965' },
  { label: 'Bahrain (+973)', code: '+973' },
  { label: 'Oman (+968)', code: '+968' },
  { label: 'Israel (+972)', code: '+972' },
  // Africa
  { label: 'South Africa (+27)', code: '+27' },
  { label: 'Egypt (+20)', code: '+20' },
  { label: 'Nigeria (+234)', code: '+234' },
  { label: 'Kenya (+254)', code: '+254' },
  { label: 'Ethiopia (+251)', code: '+251' },
];
